<ion-grid class="sis-numberpicker-grid" [class]="floatRight ? 'sis-float-right' : ''">
  <ion-row>
    <ion-col
      class="sis-btn-col"
      [ngStyle]="{ 'background-color': color }"
      size="3.5"
      (click)="decrement()"
      data-test="number-picker-decrement"
      >-</ion-col
    >
    <ion-col
      size="5"
      [ngStyle]="{ fontSize: fontSize }"
      style="border-top: 1px solid gray; border-bottom: 1px solid gray"
      >{{ displayedValue }}{{ unit }}</ion-col
    >
    <ion-col
      class="sis-btn-col"
      [ngStyle]="{ 'background-color': color }"
      size="3.5"
      (click)="increment()"
      data-test="number-picker-increment"
      >+</ion-col
    >
  </ion-row>
</ion-grid>
